import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=5f06f1e7&scoped=true"
import script from "./UserFilter.vue?vue&type=script&lang=js"
export * from "./UserFilter.vue?vue&type=script&lang=js"
import style0 from "./UserFilter.vue?vue&type=style&index=0&id=5f06f1e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06f1e7",
  null
  
)

export default component.exports